/**
 * Extracts the video ID from a YouTube URL.
 * Supports Shorts (youtube.com/shorts/ID), watch (youtube.com/watch?v=ID),
 * youtu.be/ID, and embed (youtube.com/embed/ID).
 */

/** YouTube video ID is 11 chars (alphanumeric, underscore, hyphen) */
const YOUTUBE_ID_PATTERN = '[a-zA-Z0-9_-]{11}';

export default function extractVideoId(videoUri: string | undefined) {
  if (!videoUri || typeof videoUri !== 'string') return '';

  const shortsMatch = videoUri.match(
    new RegExp(`(?:youtube\\.com/shorts/)(${YOUTUBE_ID_PATTERN})`)
  );
  if (shortsMatch?.[1]) return shortsMatch[1];

  const watchMatch = videoUri.match(
    new RegExp(`(?:[?&]v=)(${YOUTUBE_ID_PATTERN})`)
  );
  if (watchMatch?.[1]) return watchMatch[1];

  const shortLinkMatch = videoUri.match(
    new RegExp(`(?:youtu\\.be/)(${YOUTUBE_ID_PATTERN})`)
  );
  if (shortLinkMatch?.[1]) return shortLinkMatch[1];

  const embedMatch = videoUri.match(
    new RegExp(`(?:youtube\\.com/embed/)(${YOUTUBE_ID_PATTERN})`)
  );
  if (embedMatch?.[1]) return embedMatch[1];

  return '';
}
